export default {
  "organizationSettings": {
    "headerTitle": "Organization Settings",
    "headerDesc": "Change the configuration of your organization's settings.",
    "saveButton": "Save",
    "generalTab": {
      "header": "General",
      "title": "General",
      "desc": "This default settings will be applied to the entire organization account.",
      "warehouseRetention": {
        "title": "Warehouse Retention Policy",
        "storageInfoLabel": "Warehouse storage",
        "storageInfoMsg": "Used space {used}/{total} GB",
        "inputLabel": "Retention period",
        "inputDesc":
          "Set your retention period. Dataset versions exceeding this period of time, will be automatically deleted. The latest dataset version is always saved regardless of the retention setting.",
        "inputInfo": "Datasets version created before {date} will be deleted at midnight.",
        "inputUnit": "days"
      }
    },
    "credentialsTab": {
      "header": "Credentials",
      "title": "Connect to the {organizationName} Warehouse",
      "desc": "Use the following credentials to connect to this organization's data warehouse.",
      "instructions": "Your personal credentials provided allow you to access sources and datasets for this organization.",
      "serverAddressLabel": "Server Address",
      "portNumberLabel": "Port",
      "databaseNameLabel": "Database Name",
      "usernameLabel": "Username",
      "passwordLabel": "Password",
      "copyButton": "Copy",
      "generateButton": "Generate",
      "resetButton": "Reset",
      "generateModal": {
        "title": "Warehouse Password for {organizationName}",
        "instructions": "Your password has been generated. It won't be accessible on the BEEM app once you quit this modal dialog.",
        "checkboxTitle": "Check the following items to reveal your password:",
        "checkboxText1": "BEEM does not store my warehouse password.",
        "checkboxText2": "My password is unrecoverable and will need to be reset in case it is lost.",
        "checkboxText3": "My password should be stored securely through a password manager or in a file.",
        "passwordLabel": "New password",
        "revealButton": "Reveal",
        "copyButton": "Copy",
        "mainButton": "I've stored my password"
      },
      "resetModal": {
        "title": "Reset Warehouse Credential Password",
        "instructions": "Warning: Resetting your password will invalidate all your passwords used in external tools. You'll need to change your password in all external tools it's been used.",
        "resetText": "Are you sure you want to reset your password?",
        "resetButton": "Reset",
        "userNotFoundError": "Aucun identifiant d'entrepôt n'existe encore pour votre compte. Générez d'abord un mot de passe avant d'essayer de le réinitialiser.",
        "errorButton": "Fermer",
        "generateButton": "Générer un mot de passe"
      }
    },
    "aiContextTab": {
      "header": "Centre IA",
      "title": "Centre IA",
      "desc": "Décrivez votre organisation aux fonctionnalités IA. L'identité et l'image de marque sont injectées comme contexte dans chaque prompt IA."
    },
    "usageTab": {
      "header": "Utilisation et\u00a0facturation",
      "title": "Utilisation et facturation",
      "desc": "Consommation pour le cycle en cours, et le forfait et les factures correspondants.",
      "usage": "Utilisation",
      "billing": "Facturation",
      "cycle": "Ce mois-ci \u00b7 depuis le {from} \u00b7 r\u00e9initialisation dans {days} jours",
      "compare": "Comparer au mois dernier",
      "thisMonth": "Ce mois-ci",
      "dataProcessing": "Traitement des donn\u00e9es",
      "dpu": "DPU",
      "dpuAllowance": "Sur {allowance} DPU inclus par cycle",
      "noDpuAllowance": "Factur\u00e9 \u00e0 la consommation \u2014 ce forfait n'inclut aucun DPU",
      "dpuIncluded": "{allowance} DPU inclus",
      "portalError": "Impossible d'ouvrir le portail de facturation. R\u00e9essayez ou contactez le support.",
      "invoiceError": "Impossible de pr\u00e9parer cette facture. R\u00e9essayez ou ouvrez le portail de facturation.",
      "storage": "Stockage",
      "dataLake": "Lac de donn\u00e9es",
      "warehouse": "Entrep\u00f4t",
      "storageCombined": "Lac de donn\u00e9es et entrep\u00f4t combin\u00e9s",
      "storageAllowance": "Sur {allowance} Go inclus par cycle",
      "storageIncluded": "{allowance} Go inclus",
      "overAllowance": "{over} Go au-del\u00e0 du stockage inclus dans ce forfait.",
      "warehouseIncludedNote": "Le stockage d'entrep\u00f4t s'ex\u00e9cute sur un entrep\u00f4t d\u00e9di\u00e9 inclus dans votre forfait; il n'est donc pas factur\u00e9 \u00e0 la consommation.",
      "chartCurrent": "Ce cycle",
      "chartPrevious": "Cycle pr\u00e9c\u00e9dent",
      "chartDay": "Jour",
      "chartNoData": "Aucune donn\u00e9e quotidienne pour l'un ou l'autre cycle.",
      "delta": "{arrow} {percent}\u00a0% vs le m\u00eame jour du cycle pr\u00e9c\u00e9dent",
      "deltaFlat": "Inchang\u00e9 par rapport au m\u00eame jour du cycle pr\u00e9c\u00e9dent",
      "portal": "G\u00e9rer la facturation",
      "planMeta": "Tous les {period} {unit}",
      "noPlan": "Aucun forfait enregistr\u00e9",
      "storageNone": "Aucune mesure pour le moment",
      "warehouseIncludedNoteWithCapacity":
        "Le stockage d\u2019entrep\u00f4t s\u2019ex\u00e9cute sur un entrep\u00f4t d\u00e9di\u00e9 inclus dans votre forfait, avec {capacity} Go provisionn\u00e9s; il n\u2019est donc pas factur\u00e9 \u00e0 la consommation.",
      "billingUnavailable": "Impossible de charger les d\u00e9tails de facturation. Veuillez r\u00e9essayer sous peu ou contacter le soutien.",
      "projectedThisCycle": "Projection pour ce cycle\u00a0: {value} {unit}",
      "projectedNextCycle": "Projection pour le prochain cycle\u00a0: {value} {unit}",
      "projectionEarly": "(d\u00e9but de cycle)",
      "projectionNoHistory": "(historique insuffisant pour une tendance)",
      "invoiceStatus": {
        "paid": "Payée",
        "posted": "À payer",
        "payment_due": "À payer",
        "not_paid": "Impayée",
        "voided": "Annulée",
        "pending": "En attente"
      },
      "invoices": "Factures r\u00e9centes",
      "noBilling": "La facturation de cette organisation n'est pas g\u00e9r\u00e9e dans Chargebee."
    },
    "usersTab": {
      "header": "Users & Access",
      "title": "Manage access",
      "desc": "Manage user organization and workspace roles, memberships and ownership of accounts that have access to your organization.",
      "filter": "Filter members by name or username",
      "subtitles": {
        "user": "{numberOfUsers} Users",
        "membership": "Membership"
      },
      "workspaces": "{numberOfWorkspaces} Workspaces",
      "dropdown": {
        "delete": "Remove from organization"
      }
    }
  }
};
